// src/components/FeaturedDishes.jsx
import React from "react";

function FeaturedDishes() {
const items = [
  {
    name: "Chicken Momo",
    img: "menu/momo-real1.png",
    desc: "Classic Nepalese dumplings filled with spiced chicken."
  },
  {
    name: "Butter Chicken",
    img: "/menu/curry-real1.png",
    desc: "Creamy tomato-based curry with tender chicken."
  },
  {
    name: "Veg Biryani",
    img: "/menu/biryani-real1.png",
    desc: "Aromatic basmati rice cooked with fresh vegetables."
  }
];

  return (
    <section className="featured-dishes">
      <h2>Customer Favourites</h2>

      <div className="featured-grid">
        {items.map((item, i) => (
          <div className="featured-card" key={i}>
            <img src={item.img} alt={item.name} />

            <h3>{item.name}</h3>
            <p>{item.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default FeaturedDishes;
